const BULLET_PREFIX = '• ';

/** Converte marcadores de lista no início da linha para bolinha visível. */
export const normalizeProntuarioNotesInput = (value: string): string =>
	value.replace(/^(?:-|\*)\s/gm, BULLET_PREFIX);
